import { Fragment } from "react";
import PropTypes from "prop-types";
import { path, head } from "ramda";

import { CONTENT_TYPES } from "utils/contentful";
import MetaTags from "components/MetaTags";
import MainTitle from "components/MainTitle";

import Text from "./components/Text";
import Menu from "./components/Menu";

const ContentfulPage = ({ data, eventClick = true }) => {
  const getContentTypeId = (pageModule) => {
    return path(["sys", "contentType", "sys", "id"], pageModule);
  };

  const getPageModuleId = (pageModule) => {
    return path(["sys", "id"], pageModule);
  };

  const renderPageModule = (pageModule) => {
    const contentTypeId = getContentTypeId(pageModule);

    switch (contentTypeId) {
      case CONTENT_TYPES.moduleText: {
        return <Text pageModule={pageModule} />;
      }
      case CONTENT_TYPES.moduleMenu: {
        return <Menu eventClick={eventClick} pageModule={pageModule} />;
      }
      default:
        return null;
    }
  };

  const { title, pageModules, seo } = path(["fields"], head(data));
  const seoTitle = seo?.fields?.title || title || "";
  const seoDescription = seo?.fields?.description || "";
  const seoIndexable = seo?.fields?.isIndexable;

  return (
    <>
      {pageModules.map((pageModule) => (
        <Fragment key={getPageModuleId(pageModule)}>{renderPageModule(pageModule)}</Fragment>
      ))}
      <MainTitle title={seoTitle} />
      <MetaTags>
        <meta name="description" content={seoDescription} />
        {!seoIndexable && <meta name="robots" content="noindex,nofollow" />}
      </MetaTags>
    </>
  );
};

ContentfulPage.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  eventClick: PropTypes.bool,
};

export default ContentfulPage;
